type Optional<T> = T | undefined;

/** e.g. "12/01/2023 */
export const NumericDateFormat = new Intl.DateTimeFormat("en-US", {
  day: "numeric",
  month: "numeric",
  year: "numeric",
});

/** e.g. "December 1, 2023" */
export const ProseDateFormat = new Intl.DateTimeFormat("en-US", {
  day: "numeric",
  month: "long",
  year: "numeric",
});

export const capitalize = (str: Optional<string>): string =>
  !str ? "" : str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

export const titleCase = (str: Optional<string>): string =>
  !str ? "" : str.split(" ").map(capitalize).join(" ");

/**
 * An extension of the native Array ".join()" primed for prose copy
 * through its strategic use of commas and the "and" conjunction.
 * No oxford comma!
 */
export const joinWithoutOxfordComma = (
  phrases: string[],
  conjunction = "and"
): string =>
  phrases.length > 1
    ? `${phrases.slice(0, -1).join(", ")} ${conjunction} ${
        phrases[phrases.length - 1]
      }`
    : phrases[0] ?? "";
